<template>
    <div class="byos-content-width px-3">
        <div class="row">
            <div class="col-12 byos-nav-links-and-headings-container byos-content-width d-block">
                <div class="byos-nav-headings-container">
                    <div v-if="currentStage === 'tagsAndRibbons'" class="byos-tags-and-ribbons-headings-container filter-stage-headings">
                        <h3 class="tags-and-ribbons-heading h1" v-html="$t('singletagandribbon.heading')">
                        </h3>
                    </div>
                    <div v-if="currentStage === 'review'" class="byos-review-headings-container filter-stage-headings">
                        <h3 class="review-heading h1" v-html="$t('review.heading')"></h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { mapGetters } from "@/store/helper/vuex";
const { currentStage } = mapGetters();
</script>